<template lang="pug">
.app-navbar
  header.navbar.bg-gray
    section.navbar-section
      slot(name="left")
    section.navbar-section.navbar-right
      slot(name="right")
        a.text-light
          .fa.fa-cog.fa-2x
  .bg-error.text-center(v-if="envLabel") {{ envLabel }}
</template>

<script>
import ApiInfoService from "@/lib/ApiInfoService"

export default {
  data() {
    return {
      info: {
        name: "",
        version: "",
        env: "",
        env_label: "",
        production: false,
      },
    }
  },

  computed: {
    envLabel() {
      if (this.info && this.info.env_label && !this.info.production) {
        return this.info.env_label
      }

      return ""
    },
  },

  created() {
    this.$set(this, "info", ApiInfoService.getInfo())
  },
}
</script>

<style lang="stylus" scoped>
navbar-height = 50px;

.app-navbar {
  color: #fff !important;

  .navbar {
    padding-left: 10px;
    padding-right: 10px;
    height: navbar-height;

    .navbar-right {
      flex: 0;
    }
  }
}
</style>
